/**
 * Display helpers for partner listing vehicle identity (Milestone 2).
 */
export function partnerListingDisplayMake(listing = {}) {
  return listing.makeLabel || listing.make || listing.makeRaw || "";
}

export function partnerListingDisplayModel(listing = {}) {
  return listing.modelLabel || listing.model || listing.modelRaw || "";
}

export function partnerListingDisplayTrim(listing = {}) {
  return listing.trimLabel || listing.version || listing.trimRaw || "";
}

export function partnerListingDisplayTitle(listing = {}) {
  return [listing.year, partnerListingDisplayMake(listing), partnerListingDisplayModel(listing), partnerListingDisplayTrim(listing)]
    .filter(Boolean)
    .join(" ");
}
